import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21ZM10 7V19H20V7H10ZM4 7V19H8V7H4Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "WindowSidebar"
);
